import DashboardWrapper from "../../dashboardCommon/dashboardWrapper";
import { routeConstant } from "shared/routes/routeConstant";
import {
  builderSideBarConstants,
  mobileNavItemsBuilder,
} from "shared/utils/constants";

interface Props {
  children: any;
}

function BuilderWrapper({ children }: Props) {
  const mainPages = [
    routeConstant.builder.projects.path,
    routeConstant.builder.notifications.path,
    routeConstant.builder.accountSetting.path,
  ];

  return (
    <DashboardWrapper
      sidebarArr={builderSideBarConstants}
      mobileNavItems={mobileNavItemsBuilder}
      mainPages={mainPages}
      userType="builder"
      showMobileNavConditionally={false}
    >
      {children}
    </DashboardWrapper>
  );
}

export default BuilderWrapper;
